<template>
  <div class="performance-coming-soon-container">
    <PerformanceComingSoonPage />
  </div>
</template>

<script>
import PerformanceComingSoonPage from "@components/PerformanceComingSoonPage/PerformanceComingSoonPage.vue";
export default {
  components: {
    PerformanceComingSoonPage,
  },
};
</script>

<style lang="css" scoped>
.performance-coming-soon-container {
  width: 100%;
  position: relative;
  top: 15px;
}
</style>
